import { OvalLoader } from "../../../components/common/Loader";

const initialsOf = (name) => {
  const parts = String(name || "")
    .trim()
    .split(/\s+/)
    .filter(Boolean);
  if (!parts.length) return "?";
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase();
};

const BirthdayCard = ({ data, hasPermission, loading }) => {
  const birthdays = data?.todays_birthday_list || [];

  if (hasPermission && !hasPermission("dashboard-birthday-list-view")) {
    return null;
  }

  const hasRows = birthdays.length > 0;
  const noun = birthdays.length === 1 ? "birthday" : "birthdays";

  return (
    <div className="insight-mini insight-mini--birthday">
      {loading ? (
        <div className="insight-mini-loading">
          <OvalLoader color="#1E3A93" />
        </div>
      ) : (
        <div className="insight-mini-main">
          {!hasRows && (
            <span className="insight-mini-icon is-pink">
              <i className="bx bx-gift" aria-hidden="true"></i>
            </span>
          )}
          <div className="insight-mini-copy">
            <div className="insight-mini-kicker">Birthdays</div>
            <div className="insight-mini-title">
              {hasRows
                ? `${birthdays.length} ${noun} today`
                : "No birthdays today"}
            </div>
            {!hasRows && (
              <div className="insight-mini-desc">Check back tomorrow.</div>
            )}
          </div>
          {hasRows && (
            <div className="insight-mini-avatars">
              {birthdays.slice(0, 3).map((user, i) => (
                <span
                  key={i}
                  className="insight-mini-avatar"
                  title={user?.name || user?.company_name || "Member"}
                >
                  {initialsOf(user?.name || user?.company_name)}
                </span>
              ))}
              {birthdays.length > 3 && (
                <span className="insight-mini-more">+{birthdays.length - 3}</span>
              )}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default BirthdayCard;
